<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="bg-white shadow-sm-light">
        <app-info-appel [base]="'applicationOffTrack'" [cohorte]="cohorte"></app-info-appel>

        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/candidaturesHS/' + cohorte]"
                class="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group">
                <svg class="w-5 h-5 me-2 text-blue-600 dark:text-blue-500" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd" />
                </svg>

                Candidatures
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/admisHS/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd" />
                </svg>

                Admis
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statistiquesHS/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667" />
                </svg>
                Statistiques
              </a>
            </li>
            <li class="me-2">
              <a [routerLink]="['/dashboard/appels/statconnectionHP/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center whitespace-nowrap p-4 text-gray-600 border-b-2 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300">
                <svg class="w-2 h-6 text-gray-600 dark:text-white mr-2 shrink-0" id="icon" viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M30,30H22V4h8Zm-6-2h4V6H24Z"></path>
                  <path d="M20,30H12V12h8Z"></path>
                  <path d="M10,30H2V18h8Z"></path>
                  <rect data-name="<Transparent Rectangle>" id="_Transparent_Rectangle_"></rect>
                </svg>

                Statistiques de connexion
              </a>
            </li>

            <!-- <li>
              <a
                class="inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
                >Disabled</a
              >
            </li> -->
          </ul>
        </div>
      </div>
      <!-- </div> -->

      <div
        class="text-center w-full p-2 bg-white delib-screen p00 flex-col justify-start items-start gap-2.5 inline-flex">
        <div class="text-center w-full p01 p-2 bg-white flex-col justify-start items-start gap-2.5 inline-flex">
          <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
            <div class="self-stretch flex-col justify-start items-center gap-6 flex">
              <div class="self-stretch flex-col justify-start items-start gap-6 flex">
                <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex">
                  <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                    <div class="self-stretch text-gray-900 text-3xl font-semibold leading-[38px] mt-5">
                      Répartitions des candidatures
                    </div>
                  </div>
                </div>
                <div class="justify-center items-start flex w-full flex-column gap-8 sm:flex-row align-items: center">
                  <div class="flex tab-ctnr max-w-full overflow-x-auto">
                    <div class="ctnr-tableau-recap">
                      <table class="tableau-recap text-gray-900">
                        <thead class="align-center">
                          <tr class="border-b border-t border-gray-200 dark:border-gray-700">
                            <th class="px-8 py-2 inter-semibold"></th>
                            <th class="px-8 py-2 inter-semibold light-blue-bg">
                              Hommes
                            </th>
                            <th class="px-8 py-2 inter-semibold light-blue-bg">
                              Femmes
                            </th>
                            <th class="px-8 py-2 inter-semibold light-blue-bg">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="border-b border-gray-200 dark:border-gray-700">
                            <th class="px-8 py-2 inter-semibold light-blue-bg text-left">
                              Candidats
                            </th>
                            <td class="px-8 py-2 inter-medium light-blue-bg">
                              {{ homme }}
                            </td>
                            <td class="px-8 py-2 inter-medium light-blue-bg">
                              {{ femme }}
                            </td>
                            <td class="px-8 py-2 inter-medium light-blue-bg">
                              {{ homme + femme }}
                            </td>
                          </tr>

                          <tr></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- <div class="line gap-3 flex justify-end items-end">
                    <div class="pad">
                      <button type="file" (click)="exportTableOfStats()"
                        class="font-semibold text-white mat-mdc-input-element bg-blue self-stretch mt-4 px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex">
                        Exporter en XLS
                      </button>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-center w-full p-2 candidatures-one delib-screen flex-col justify-start items-start gap-2.5 inline-flex mt-8"
            style="background-color: #f3f8fe">
            <div
              class="text-center w-full p-2 candidatures-one delib-screen flex-col justify-start items-start gap-2.5 inline-flex">
              <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
                <div class="self-stretch flex-col justify-start items-center gap-2 flex">
                  <div
                    class="px-8 w-full flex-column gap-4 sm:flex-row align-items-center tab-container flex justify-center items-center mt-6">
                    <button (click)="prevButton()" [disabled]="currentButton === 1" class="font-bold">
                      Précédent
                    </button>

                    <button *ngFor="let button of paginatedButtons"
                      class="px-4 cst-transition py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex tab-button"
                      (click)="setPage(button.id)">
                      {{ button.label }}
                    </button>
                    <button (click)="nextButton()" [disabled]="
                        currentButton * buttonsPerPage >= totalButtons
                      " class="font-bold">
                      Suivant
                    </button>
                  </div>

                  <div class="self-stretch form-ctnr flex-col justify-start items-center gap-4 flex">
                    <form class="said-form" [formGroup]="formGroup"></form>

                    <div
                      class="justify-center items-start flex w-full flex-column gap-4 sm:flex-row align-items: center justify-content-evenly">
                      <div class="w-full">
                        <div *ngIf="currentPage === 1" class="graph-ctnr said-tarte">
                          <canvas id="canvasGender" #canvasGender></canvas>
                        </div>
                      </div>
                      <div class="w-full">
                        <div *ngIf="currentPage === 1" class="graph-ctnr said-tarte">
                          <canvas id="canvasNationality" #canvasNationality></canvas>
                        </div>
                      </div>
                    </div>

                    <!--   <div *ngIf="currentPage === 2" class="graph-ctnr said-tarte">
            <canvas id="canvasStatus" #canvasStatus></canvas>
          </div>  -->

                    <div *ngIf="currentPage === 2" class="graph-ctnr said-bar">
                      <canvas id="canvasStatusVertical" #canvasStatusVertical></canvas>

                      <table class="chart-table">
                        <thead>
                          <tr>
                            <th>Data</th>
                            <th>Responses</th>
                            <th>Pourcentage</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let label of chartLabels; let i = index">
                            <td>{{ label }}</td>
                            <td>{{ chartData[i] }}</td>
                            <td>
                              {{ chartPercentages[i] || chartPercentages[0] }}%
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div *ngIf="currentPage === 3" class="graph-ctnr said-bar">
                      <canvas id="canvasLevel" #canvasLevel></canvas>
                    </div>
                    <!-- 
          <div *ngIf="currentPage === 5" class="graph-ctnr said-bar">
            <canvas id="canvasRightStatus" #canvasRightStatus></canvas>
          </div>  -->

                    <!--   <div class="flex-row justify-center items-start gap-8 flex">
            <div>
              <div *ngIf="currentPage === 4" class="graph-ctnr said-tarte">
                <canvas id="canvasRightHandicap" #canvasRightHandicap></canvas>
              </div>
            </div>
            <div>
              <div *ngIf="currentPage === 4" class="graph-ctnr said-tarte">
                <canvas id="canvasFamily" #canvasFamily></canvas>
              </div>
            </div>
          </div> -->

                    <!-- 
          <div class="flex-row justify-center items-start gap-8 flex">
            <div *ngIf="currentPage === 4" class="graph-ctnr said-tarte">
              <canvas id="canvasForceNKnow" #canvasForceNKnow></canvas>
            </div>
            <div *ngIf="currentPage === 4" class="graph-ctnr said-tarte">
              <canvas id="canvasProjetIssu" #canvasProjetIssu></canvas>
            </div> 
          </div> -->

                    <div *ngIf="currentPage === 4" class="graph-ctnr said-bar">
                      <canvas id="canvasCertified" #canvasCertified></canvas>
                    </div>

                    <div *ngIf="currentPage === 5" class="graph-ctnr said-bar">
                      <canvas id="canvasHightDiplome" #canvasHightDiplome></canvas>
                    </div>

                    <!--  <div *ngIf="currentPage === 10"  class="graph-ctnr said-bar">
            <canvas id="canvasSeriebac" #canvasSeriebac></canvas>
          </div>  -->

                    <!--  <div *ngIf="currentPage === 6"  class="graph-ctnr said-bar">
            <canvas id="canvasDesciDutBts" #canvasDesciDutBts></canvas>
          </div>  -->

                    <!-- <div *ngIf="currentPage === 7"  class="graph-ctnr said-bar">
            <canvas id="canvasDesciLicenceMaster" #canvasDesciLicenceMaster></canvas>
          </div> -->

                    <div *ngIf="currentPage === 6" class="graph-ctnr said-bar">
                      <canvas id="canvasDisponible" #canvasDisponible></canvas>
                    </div>

                    <div *ngIf="currentPage === 7" class="graph-ctnr said-bar">
                      <canvas id="canvasRegion" #canvasRegion></canvas>
                    </div>

                    <div class="button-container gap-2">
                      <button (click)="previousPage()" [disabled]="currentPage === 1" class="btn text-sm font-semibold">
                        Retour
                      </button>
                      <button (click)="nextPage()" [disabled]="currentPage === 7" class="btn text-sm font-semibold">
                        Suivant
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>